import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { applyCoffreTheme, clearCoffreDocumentThemeClasses, readCoffreTheme } from "./coffreTheme.js";

clearCoffreDocumentThemeClasses();
applyCoffreTheme(readCoffreTheme());

async function bootstrap() {
  if (!window.__SUITE_SHARED_READY__) {
    await new Promise((resolve) => {
      document.addEventListener("suiteSharedReady", resolve, { once: true });
    });
  }

  const { startCoffreSuiteAuth } = await import("./initCoffreSuiteAuth.js");
  startCoffreSuiteAuth();

  const { default: CoffreApp } = await import("./CoffreApp.jsx");
  const rootEl = document.getElementById("root");
  if (rootEl) {
    createRoot(rootEl).render(
      <React.StrictMode>
        <CoffreApp />
      </React.StrictMode>
    );
  }
}

bootstrap();
